import { makeStyles } from "@material-ui/core";

export const useMessagesStyles = makeStyles(theme => ({
  messagesRoot: {
    //    backgroundColor: "#0f0f0f",
    color: "#fff",
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    flexDirection: "column",
    alignItems: "center",
  },
  messagesMain: {
    display: "flex",
    padding: "20px 25px 25px 25px",
    width: "100%",
    columnGap: "10px",
    height: "100%",
    flexGrow: 1,
    [theme.breakpoints.down("md")]: {
      padding: "15px 20px",
      columnGap: "8px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      columnGap: "0px",
      height: "calc(100vh - 70px)",
    },
  },
  headerTitle: {
    fontSize: "31px",
    fontWeight: 500,
    color: "#f06ec4",
    [theme.breakpoints.down("md")]: {
      fontSize: "28px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  headerPar: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#D9D3D3",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatSidebar: {
    width: "550px",
    maxWidth: "550px",
    minWidth: "550px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.down("lg")]: {
      width: "450px",
      maxWidth: "450px",
      minWidth: "450px",
    },
    [theme.breakpoints.down("md")]: {
      width: "400px",
      maxWidth: "400px",
      minWidth: "400px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
      position: "absolute",
      top: "70px",
      left: 0,
      height: "calc(100vh - 70px)",
      zIndex: 1000,
      backgroundColor: "#0f0f0f",
      padding: "20px",
      boxSizing: "border-box",
    },
  },
  searchTypeButton: {
    minWidth: 120,
    color: "#707C97",
    backgroundColor: "#131313",
    borderLeft: "1px solid #363636",
    borderRadius: "0px",
  },
  menu: {
    "& .MuiPaper-root": {
      color: "#707C97",

      borderRadius: 8,
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      minWidth: 150,
    },
    "& .MuiMenuItem-root": {
      fontSize: "0.875rem",
      padding: theme.spacing(1, 2),
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
  menuHelp: {
    "& .MuiPaper-root": {
      color: "#707C97",
      borderRadius: 8,
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      backgroundColor: "transparent",
      display: "flex",
      columnGap: "10px",
      rowGap: "10px",
    },
    "& ul.MuiList-root": {
      display: "flex",
      flexDirection: "column",
      rowGap: "4px",
    },

    "& .MuiMenuItem-root": {
      fontSize: "0.875rem",
      display: "flex",
      columnGap: "10px",
      rowGap: "10px",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
  customAttachmentMenu: {
    position: "absolute",
    bottom: "90px", // або top: "-100px" — залежно від того, де твій input
    // left: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    // backgroundColor: "#fff",
    // padding: "10px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    zIndex: 10,
    [theme.breakpoints.down("sm")]: {
      bottom: "54px",
    },
  },

  menuPopoverRoot: {
    position: "absolute",
    inset: "auto",
  },

  mediaPreviewWrapper: {
    //     position: "relative",
    marginRight: "10px",
  },

  chatSidebarHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  chatWindow: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    border: "1px solid #363636",
    minWidth: 0,
    height: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "calc(100vh - 70px)",
    },
  },
  chatWindowHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    height: "60px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      marginBottom: theme.spacing(2),
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  headerItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      width: "100%",
    },
  },
  newChatButton: {
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "none",
    width: "240px",
    height: "50px",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#e05bb5",
    },
    [theme.breakpoints.down("lg")]: {
      width: "200px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("md")]: {
      width: "180px",
      height: "45px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "50px",
      fontSize: "16px",
    },
  },
  searchWrapper: {
    marginBottom: theme.spacing(2),
    display: "flex",
    border: "1px solid #363636",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      flexDirection: "row",
    },
  },
  chatInputMessages: {
    display: "flex",
    backgroundColor: "#131313",
    border: "1px solid #363636",
    padding: "10px",
    color: "#707C97",
    minWidth: "100px",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "12px 16px",
      fontSize: "14px",
      borderLeft: "none",
    },
  },
  searchInput: {
    backgroundColor: "#131313",
    padding: "6px 12px",
    color: "#707C97",
    width: "100%",
    "& .MuiInputBase-input::placeholder": {
      color: "#707C97",
      opacity: 1,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px 16px",
      fontSize: "14px",
    },
  },
  chatList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    overflowY: "auto",
    flexGrow: 1,
    paddingRight: "5px",
    minHeight: 0,
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#1a1a1a",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#B7BDCB",
      borderRadius: "4px",
      "&:hover": {
        background: "#A0A6B5",
      },
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      paddingRight: "2px",
    },
  },
  chatNameWrites: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#FF68D5",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatItem: {
    display: "flex",
    backgroundColor: "#131313",
    padding: "20px 15px 15px 30px",
    borderRadius: 8,
    border: "1px solid #2f2f2f",
    cursor: "pointer",
    height: "160px",
    flexDirection: "column",
    rowGap: "17px",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#1f1f1f",
    },
    [theme.breakpoints.down("md")]: {
      padding: "15px 12px 12px 20px",
      height: "160px",
      rowGap: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px 10px 10px 15px",
      height: "120px",
      rowGap: "8px",
    },
  },
  chatItemTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  chatItemLeft: {
    display: "flex",
    alignItems: "center",
    columnGap: "10px",
    [theme.breakpoints.down("sm")]: {
      columnGap: "8px",
    },
  },
  chatNameItem: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#FFFFFF",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  chatItemName: {},
  chatText: {
    flexGrow: 1,
    overflow: "hidden",
  },
  chatMessage: {
    fontSize: "15px",
    color: "#FFFFFF",
    fontWeight: 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  chatTime: {
    fontSize: "12px",
    color: "#707C97",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  chatHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "90px",
    padding: "15px",
    position: "relative",
    color: "#f06ec4",
    [theme.breakpoints.down("md")]: {
      height: "80px",
      padding: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "80px",
      padding: "10px 15px",
      marginBottom: theme.spacing(1),
    },
  },
  chatUserInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      marginLeft: "40px",
    },
  },
  chatUser: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#FFFFFF",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  chatUserNameHelp: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#FE5A97",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  chatStatus: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#FF68D5",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatHeaderActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      columnGap: "12px",
    },
  },
  chatHeaderActionButton: {
    backgroundColor: "#fff",
    color: "#000",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    padding: 0,
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
    [theme.breakpoints.down("sm")]: {
      width: "30px",
      height: "30px",
    },
  },
  messagesArea: {
    flexGrow: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: "20px",
    [theme.breakpoints.down("md")]: {
      padding: "15px",
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      gap: theme.spacing(1),
    },
  },
  messageContainer: {
    display: "flex",
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  messageContainerLeft: {
    justifyContent: "flex-start",
  },
  messageContainerRight: {
    justifyContent: "flex-end",
  },
  messageWrapper: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "70%",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      maxWidth: "75%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "80%",
    },
  },
  messageWrapperRight: {
    alignItems: "flex-end",
  },
  messageWrapperLeft: {
    alignItems: "flex-start",
  },
  messageContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    position: "relative",
  },
  messageLeft: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 400,
    padding: theme.spacing(1.5),
    borderRadius: 8,
    position: "relative",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
      padding: theme.spacing(1.2),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      padding: theme.spacing(1),
    },
  },
  messageRight: {
    backgroundColor: "#FE5A97",
    padding: theme.spacing(1.5),
    borderRadius: 8,
    color: "#FFFFFF",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1.2),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  messageMenuButton: {
    visibility: "visible",
    opacity: 1,
    transition: "all 0.2s ease",
    width: "24px",
    height: "24px",
    minWidth: "24px",
    padding: "0",
    backgroundColor: "transparent",
    color: "#fff",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "20px",
      height: "20px",
      minWidth: "20px",
    },
  },
  messageInfo: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginTop: "4px",
    fontSize: "11px",
    color: "#707C97",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  messageInfoRight: {
    justifyContent: "flex-end",
    color: "#B8B8B8",
  },
  messageInfoLeft: {
    justifyContent: "flex-start",
  },
  messageTime: {
    fontSize: "11px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  messageStatus: {
    display: "flex",
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      fontSize: "12px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "11px",
      },
    },
  },
  messageStatusRead: {
    color: "#FFFFFF",
  },
  messageStatusSent: {
    color: "#FFFFFF",
  },
  messageMenu: {
    "& .MuiPaper-root": {
      backgroundColor: "#1a1a1a",
      color: "#fff",
      border: "1px solid #363636",
    },
    "& .MuiMenuItem-root": {
      "&:hover": {
        backgroundColor: "#2a2a2a",
      },
    },
  },
  verifiedIcon: {
    color: "rgba(254, 90, 151, 1)",
  },
  nameLink: {
    textDecoration: "none",
    color: "inherit",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    "&:hover": {
      textDecoration: "none",
      color: "inherit",
      cursor: "pointer",
    },
  },
  iconButtonLabel: {
    width: "auto", // або конкретна ширина, наприклад "40px"
    marginTop: "7px",
  },

  chatInputWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "12px", // Збільшуємо відстань між елементами
    padding: "12px 16px",
    backgroundColor: "#131313",
    borderRadius: "25px",
    borderTop: "1px solid #363636",
    margin: "20px",
    marginTop: "0",
    height: "56px", // Фіксована висота замість мінімальної
    [theme.breakpoints.down("sm")]: {
      margin: "15px",
      marginTop: "0",
      padding: "8px 12px",
      height: "48px",
      gap: "8px",
    },
  },
  chatInput: {
    flexGrow: 1,
    backgroundColor: "transparent",
    padding: "10px 16px",
    color: "#fff",
    border: "none",
    outline: "none",
    height: "40px",
    fontSize: "14px",
    "&::placeholder": {
      color: "#707C97",
    },
    [theme.breakpoints.down("md")]: {
      height: "35px",
      padding: "8px 12px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "30px",
      padding: "6px 10px",
      fontSize: "14px",
    },
  },
  sendButton: {
    backgroundColor: "#FF68D5",
    color: "#fff",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    maxWidth: "40px",
    padding: "0",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#e05bb5",
    },
    [theme.breakpoints.down("sm")]: {
      width: "35px",
      height: "35px",
      minWidth: "35px",
      maxWidth: "35px",
    },
  },
  menuPaper: {
    top: "835px !important", // override inline top
  },
  chatHeaderActionsButtons: {
    display: "flex",
    columnGap: "10px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      rowGap: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      rowGap: "10px",
    },
  },

  attachmentButton: {
    color: "#FF68D5",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    maxWidth: "40px",
    padding: "0",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "rgba(255, 104, 213, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "35px",
      height: "35px",
      minWidth: "35px",
      maxWidth: "35px",
    },
  },
  attachmentButtonHelp: {
    backgroundColor: "#FF68D5",
    color: "#FFFFFF",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    maxWidth: "40px",
    padding: "0",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "rgba(255, 104, 213, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "35px",
      height: "35px",
      minWidth: "35px",
      maxWidth: "35px",
    },
  },
  mobileBackButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      position: "absolute",
      top: "50%",
      left: "10px",
      transform: "translateY(-50%)",
      zIndex: 1001,
      backgroundColor: "#FF68D5",
      color: "#fff",
      padding: "8px",
      "&:hover": {
        backgroundColor: "#e05bb5",
      },
    },
  },
  fileInput: {
    display: "none",
  },
  fileInputLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0",
    padding: "0",
    cursor: "pointer",
  },
  mediaPreview: {
    maxWidth: "60px",
    maxHeight: "60px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  modalImage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "90vw",
    maxHeight: "90vh",
    backgroundColor: "#000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    outline: "none",
  },
  modalSubscriptionWrapper: {},
  modalTipWrapper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#131313",
    padding: "0px",
    width: "500px",
    borderRadius: "16px",
    zIndex: 1401, // має бути вищий за overlay
    boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
    border: "1px solid #363636",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  modalTitle: {
    backgroundColor: "#131313",
    color: "#FE5A97",
    textAlign: "center",
    fontSize: "24px",
    padding: "20px 0",
    borderBottom: "1px solid #363636",
  },
  modalContent: {
    backgroundColor: "#131313",
    color: "#fff",
    padding: "24px",
  },
  modalSubtitle: {
    fontSize: "16px",
    marginBottom: "16px",
    lineHeight: "1.5",
    textAlign: "center",
  },
  tipInputContainer: {
    marginTop: "8px",
  },
  tipLabel: {
    marginBottom: "8px",
    fontSize: "14px",
  },
  tipInput: {
    "& input": {
      color: "#fff",
      backgroundColor: "#1e1e1e",
      MozAppearance: "textfield", // Firefox
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    // Вимикає стрілки в Chrome/Safari
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
  modalActions: {
    backgroundColor: "#131313",
    borderTop: "1px solid #363636",
    padding: "16px",
    justifyContent: "space-between",
  },
  cancelButton: {
    color: "#fff",
    backgroundColor: "#333",
    "&:hover": {
      backgroundColor: "#444",
    },
  },
  nameButSup: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.0,
  },
  buttonAction: {
    backgroundColor: "#EFEFEF",
    color: "#F05D94",
    textTransform: "none",
    padding: theme.spacing(0.5, 1),
    borderRadius: "6px",
    boxShadow: "none",
    fontSize: "0.85rem",
    width: "105px",
    height: "40px",
    "&:hover": {
      backgroundColor: "rgba(240,110,196,0.1)",
    },
    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(0.5),
      "& svg": {
        width: 16,
        height: 16,
      },
    },
    [theme.breakpoints.down("md")]: {
      MaxWidth: "105px",
      width: "125px",
      height: "22px",
    },
    [theme.breakpoints.down("sm")]: {
      MaxWidth: "105px",
      width: "125px",
      height: "22px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0.25, 0.75),
      fontSize: "0.7rem",
      "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.25),
        "& svg": {
          width: 14,
          height: 14,
        },
      },
    },
  },
  buttonActionVideo: {
    backgroundColor: "#EFEFEF",
    color: "#F05D94",
    textTransform: "none",
    padding: theme.spacing(0.5, 1),
    borderRadius: "6px",
    boxShadow: "none",
    fontSize: "0.85rem",
    width: "125px",
    height: "40px",
    "&:hover": {
      backgroundColor: "rgba(240,110,196,0.1)",
    },
    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(0.5),
      "& svg": {
        width: 16,
        height: 16,
      },
    },
    [theme.breakpoints.down("md")]: {
      MaxWidth: "105px",
      height: "32px",
    },
    [theme.breakpoints.down("sm")]: {
      MaxWidth: "105px",
      height: "32px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0.25, 0.75),
      fontSize: "0.7rem",
      "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.25),
        "& svg": {
          width: 14,
          height: 14,
        },
      },
    },
  },
  sendButtonHelp: {
    color: "#fff",
    backgroundColor: "#FE5A97",
    "&:hover": {
      backgroundColor: "#E5497F",
    },
  },
  mediaModalButon: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "500px",
    width: "500px",
    backgroundColor: "#131313",
    [theme.breakpoints.down("sm")]: {
      width: "400px",
    },
  },
  mediaModalContentInfo: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
  mediaModalTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FE5A97",
  },
  selectButton: {
    background: "#EFEFEF",
    color: "#FE5A97",
    padding: "10px 20px",
    borderRadius: "6px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#EFEFEF",
    },
  },
  boxSmile: {
    position: "absolute",
    bottom: "90px",
    right: "25px",
    zIndex: 1000,
    [theme.breakpoints.down("sm")]: {
      bottom: "54px",
      right: "15px",
    },
  },
  purchaseButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    //   backgroundColor: "#FE5A97",
    color: "#FE5A97",
    border: "1px solid #FE5A97",
    textTransform: "none",
    padding: theme.spacing(1, 2),
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#e04e87",
      color: "#FFFFFF",
      cursor: "pointer",
    },
    zIndex: 2,
  },
  dialogTitleGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#131313",
    color: "#FE5A97",
    fontSize: "24px",
    borderBottom: "1px solid #363636",
  },
  dialogContentGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#131313",
    color: "#FE5A97",
    fontSize: "14px",
    borderBottom: "1px solid #363636",
  },
  textFieldGroup: {
    color: "#fff",
    width: "300px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    padding: "10px 20px",
    backgroundColor: "#1e1e1e",
    //  backgroundColor: "#EFEFEF",
    border: "1px solid #363636",
    "& .MuiInputBase-root": {
      color: "#FFFFFF", // 🎯 колір тексту
    },
    "& .MuiInput-underline:hover": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
  },
  groupChatuserBox: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
  },
  boxUserGroup: {
    border: "1px solid #444",
    borderRadius: 8,
    padding: "5px 12px",
    cursor: "pointer",
    width: "500px",
    height: "50px",
    backgroundColor: "rgb(51, 51, 51)",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#2a2a2a",
    },
    [theme.breakpoints.down("sm")]: {
      width: "370px",
    },
  },
  dialogMinTitleGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#131313",
    color: "#FE5A97",
    fontSize: "14px",
    paddingTop: "10px",
    margin: 0,
    padding: "0",
  },

  selectedUser: {
    backgroundColor: "#FE5A97", // або будь-який твій активний колір
    //  color: "#fff",
    color: "rgb(51, 51, 51)",
    "&:hover": {
      backgroundColor: "#f94d8f",
    },
  },
  avatarUserGroup: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    objectFit: "cover",
  },
  nameUserNameGroup: {
    display: "flex",
    flexDirection: "column",
    fontSize: "12px",
  },
  dialogActionsGroupFooter: {
    backgroundColor: "#131313",
    display: "flex",
    justifyContent: "space-between",
  },
  dialogActionsGroupFooterCancel: {
    color: "#fff",
    backgroundColor: "#333",
  },
  dialogActionsGroupFooterCreate: {
    color: "#fff",
    backgroundColor: "#FE5A97",
  },
}));
